import { castArray, forEach } from 'lodash';
import Wix from '../services/wix-sdk-polyfill';

export default function subscribeMiddleware(subscribe, unsubscribe, source) {
  const sources = castArray(source);
  return store => {
    initializePubSub(subscribe, unsubscribe, sources, store);
    return next => action => next(action);
  };
}

function initializePubSub(subscribe, unsubscribe, sources, store) {
  let isSubscribed = false;

  const handleEvent = event => {
    store.dispatch(event.data);
  };

  const subscribeIfNeeded = () => {
    if (!isSubscribed) {
      forEach(sources, source => subscribe(source, handleEvent));
      isSubscribed = true;
    }
  };

  const unsubscribeIfNeeded = () => {
    if (isSubscribed) {
      forEach(sources, source => unsubscribe(source, handleEvent));
      isSubscribed = false;
    }
  };

  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_OUT, unsubscribeIfNeeded);
  Wix.addEventListener(Wix.Events.PAGE_NAVIGATION_IN, subscribeIfNeeded);
  subscribeIfNeeded();
}
